import { CommonPipesModule } from './shared/pipes/common-pipes.module';
import { EntityCafModule } from 'app/entities/caf/entity-caf.module';
import { EntityAuditModule } from './entities/audit/entity-audit.module';

import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { Angular2FontAwesomeModule } from 'angular2-font-awesome/angular2-font-awesome';
import { DatepickerModule } from 'angular2-material-datepicker';
import { CacheLocalStorage, CacheService, CacheStorageAbstract } from 'ng2-cache-service';
import { TabViewModule, DataTableModule, MultiSelectModule, DialogModule, AutoCompleteModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { DnbdashboardComponent } from 'app/dnbdashboard/dnbdashboard.component';

import { ContentComponent } from 'app/clients/client/content/content.component';

import { ClientHeaderModule } from 'app/clients/client/header/client-header.module';
import { ClientHeaderService } from 'app/clients/client/header/client-header.service';
import { PersonHeaderModule } from 'app/person/header/person-header.module';

// TODO optimize these imports (e.g. by joining them in specific modules)
import { EntityDossierComponent } from 'app/entities/entity-dossier.component';
import { PersonDossierTabsComponent } from 'app/entities/person-dossier-tabs.component';
import { ClientDossierTabsComponent } from 'app/entities/client-dossier-tabs.component';
import { OrgDossierTabsComponent } from 'app/entities/org-dossier-tabs.component';

import { EntityRelationsModule } from 'app/entities/relations/entity-relations.module';
import { EntityEmailsComponent } from 'app/entities/emails/emails.component';
import { EntityTimeTrackingComponent } from 'app/entities/time-tracking/entity-time-tracking.component';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';
import { EntityOtherService } from 'app/entities/other/entity-other.service';

import { HeaderComponent } from 'app/header/header.component';
import { ClientsOverviewComponent } from 'app/clients/overview/clients-overview.component';
import { ClientWidgetItemComponent } from 'app/clients/client/widget/client-widget-item.component';
import { ClientReviewComponent } from 'app/clients/reviews/client-review.component';
import { ReviewComponent } from 'app/clients/reviews/review/review.component';
import { NavigationBarComponent } from 'app/header/navigationbar/navigation-bar.component';
import { NavigationBarModule } from 'app/header/navigationbar/navigation-bar.module';
import { NavigationBarService } from 'app/header/navigationbar/navigation-bar.service';
import { LogoutService } from 'app/header/usersettings/logout.service';
import { UserSettingsComponent } from 'app/header/usersettings/user-settings.component';
import { ChangePasswordComponent } from 'app/header/usersettings/changepassword/change-password.component';
import { UserPreferencesComponent } from 'app/header/usersettings/userpreferences/user-preferences.component';
import { SessionExpiredComponent } from 'app/shared/components/sessionexpired/session-expired.component';

import { ArchivalModule } from 'app/admin/archival/archival.module';
import { FinanceModule } from 'app/finance/finance.module';
import { GroupModule } from 'app/admin/groups/group.module';
import { IntegrationsModule } from 'app/admin/integrations/integrations.module';
import { ProcessModule } from 'app/admin/processes/process.module';
import { RuleModule } from 'app/admin/rules/rule.module';
import { SurveyModule } from 'app/admin/survey/survey.module';
import { TaskModule } from 'app/task/task.module';
import { UsersModule } from 'app/admin/users/users.module';
import { TenantConfigurationModule } from 'app/admin/tenantconfiguration/tenant-configuration.module';

import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { CanDeactivateGuard } from 'app/services/can-deactivate.service';
import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { GlobalValuesService } from 'app/services/global-values.service';
import { SidebarService } from 'app/services/sidebar.service';
import { SidebarTasksService } from 'app/services/sidebar-tasks.service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { PromiseRequestService } from 'app/services/promise-request.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { UserIdleService } from 'app/services/user-idle.service';

import { EntityDetailsModule } from 'app/entities/details/entity-details.module';
import { EntityDocumentsModule } from 'app/entities/documents/entity-documents.module';
import { EntityFinanceModule } from 'app/entities/finance/entity-finance.module';
import { EntityMonitoringModule } from 'app/entities/monitoring/entity-monitoring.module';
import { PendingHitsOverviewModule } from 'app/entities/monitoring/pending-hits-overview/pending-hits-overview.module';
import { AlertsModule } from 'app/alerts/alerts.module';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';
import { EntitySurveysModule } from 'app/entities/surveys/entity-surveys.module';
import { ReportsModule } from 'app/reports/reports.module';
import { ApplicationActivityModule } from 'app/admin/applicationactivity/application-activity.module';

import { EntityTransactionProfileModule } from 'app/entities/transaction-profile/entity-transaction-profile.module';
import { ServiceModule } from 'app/admin/services/service.module';

import { AppRoutingModule } from 'app/app-routing.module';
import { AppComponent } from './app.component';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { EntityEmailModule } from 'app/entities/emails/emails-module';
import { ImportClientModule } from 'app/admin/importclient/import-client.module';
import { EntityTransactionMonitoringModule } from 'app/entities/transaction-monitoring/entity-transaction-monitoring.module';
import {WorkflowModule} from './workflow/workflow.module';
import { EntityNewCafComponent } from './entity-new-caf/entity-new-caf.component';
import { ImportComponent } from './admin/import/import.component';
import {ImportController} from './admin/import/import.controller';
import {ReviewImportComponent} from './admin/import/review/review-import.component';
import {FilterCounterpartiesDialogComponent} from './admin/import/review/filter-counterparties-dialog.component';
import {CreateCounterpartyDialogComponent} from './admin/import/review/create-counterparty-dialog.component';
import { TransactionProfileExportComponent } from './admin/transaction-profile-export/transaction-profile-export.component';
import { EntityRouteService } from 'app/entities/entity-route.service';


@NgModule({
  declarations: [
    AppComponent,
    UserPreferencesComponent,
    ContentComponent,
    EntityDossierComponent,
    PersonDossierTabsComponent,
    OrgDossierTabsComponent,
    ClientDossierTabsComponent,
    EntityTimeTrackingComponent,
    EntityOtherComponent,
    HeaderComponent,
    UserSettingsComponent,
    NavigationBarComponent,
    SessionExpiredComponent,
    ChangePasswordComponent,
    ClientsOverviewComponent,
    ClientWidgetItemComponent,
    ClientReviewComponent,
    ReviewComponent,
    DashboardComponent,
    DnbdashboardComponent,
    EntityNewCafComponent,
    ImportComponent,
    ReviewImportComponent,
    FilterCounterpartiesDialogComponent,
    CreateCounterpartyDialogComponent,
    TransactionProfileExportComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    DialogModule,
    MaterialModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    Angular2FontAwesomeModule,
    FlexLayoutModule.forRoot(),
    DatepickerModule,
    NgIdleKeepaliveModule.forRoot(),
    MultiSelectModule,
    AutoCompleteModule,
    SharedModule,
    TabViewModule,
    DataTableModule,
    NavigationBarModule,
    //
    ClientHeaderModule,
    PersonHeaderModule,
    EntityDetailsModule,
    EntityMonitoringModule,
    PendingHitsOverviewModule,
    AlertsModule,
    EntityTransactionProfileModule,
    EntityRelationsModule,
    EntityAuditModule,
    EntityDocumentsModule,
    EntityFinanceModule,
    EntityCafModule,
    FinanceModule,
    TaskModule,
    EntitySurveysModule,
    ReportsModule,
    TenantConfigurationModule,
    //
    UsersModule,
    ArchivalModule,
    ApplicationActivityModule,
    IntegrationsModule,
    SurveyModule,
    GroupModule,
    ProcessModule,
    RuleModule,
    InfiniteScrollModule,
    ServiceModule,
    EntityEmailModule,
    InfiniteScrollModule,
    CommonPipesModule,
    ImportClientModule,
    EntityTransactionMonitoringModule,
    WorkflowModule
  ],
  providers: [
    PromiseRequestService,
    ObservableRequestService,
    { provide: 'isAuthApp', useValue: false },
    ConstantsService,
    CookieService,
    CacheService,
    [{ provide: CacheStorageAbstract, useClass: CacheLocalStorage }],
    WarmUpService,
    UserIdleService,
    GlobalValuesService,
    SidebarService,
    EntityOtherService,
    SidebarTasksService,
    SnackBarService,
    AuthenticationGuard,
    CanDeactivateGuard,
    LogoutService,
    NavigationBarService,
    ClientHeaderService,
    EntityRouteService,
    EntityMonitoringService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    ImportController
  ],
  entryComponents: [
    AppComponent,
    SessionExpiredComponent,
    ChangePasswordComponent,
    FilterCounterpartiesDialogComponent,
    CreateCounterpartyDialogComponent
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts